import { css } from 'lit';

import color from '../../utils/get-color-token';
import token from '../../utils/get-token';

function styles() {
	return [
		css`
			.toggle-group {
				inline-size: max-content;

				border: 1px solid ${color('color-border')};
				padding: ${token('spacing-1')};

				border-radius: ${token('border-radius-s')};
				box-sizing: border-box;

				block-size: ${token('global-height-default')};
			}

			.toggle-group.-small {
				block-size: ${token('global-height-small')};
			}

			.toggle-group.-small ::slotted(m-toggle) {
				--m-toggle-base-size: 18px;
				--m-toggle-font-size: ${token('font-size-2')};
				--m-toggle-icon-size: 10px;
			}

			.toggle-group.-show-check ::slotted(m-toggle[aria-checked='true']) {
				--m-toggle-icon-display: inline-flex;
			}
		`,
	];
}

export default styles;
